import { useCall } from "@/hooks/useCall/useCall";
import { useBaseStore } from "@/store/store";

/**
 * A call has no information to display when it carries neither a recording nor
 * a transcription. True for unanswered outbound calls, missed calls, and every
 * call on a line with recording switched off - the rule must never gate the
 * whole page (Call info / Notes stay meaningful), only the media UI: the
 * transcript panel and the header's speaker line, which would otherwise list
 * people who never spoke (CI-6280, CI-6374, CI-6448).
 */
export function useNoInformationRule() {
  const { call } = useCall();
  const audio = useBaseStore((store) => store.audio);

  const hasNoInformation = !!call && !audio?.url && !call.transcription;

  return { hasNoInformation };
}
